export const stringValue = (value) => typeof value === "string" && value.length > 0;